module.exports = __webpack_public_path__ + "static/img/spring_pipaPic.7d132a36.png";